export default __webpack_public_path__ + "static/media/logo.a57410b5.png";